<!--TODO: Need to refactor: this code the same as wgnp/static_source/components/sms_verification_code_form/sms_verification_code_form.vue.html-->
<form
    novalidate="novalidate"
    :action="actualSubmitUrl"
    @submit.prevent="submitForm"
    class="two-fa-steps two-fa-steps__pass-change"
    method="POST"
    ref="smsTplForm">

    <b-message-error
        v-if="errorType.main"
        :errorParams="mainErrorParams" />

    <slot></slot>

    <fieldset class="fieldset-code">
        <div class="fieldset-code_input">
            <div class="form-input">
                <input
                    v-focus
                    v-maxlength
                    v-model="code"
                    :data-at-role="qaDataAttributes.code || 'code'"
                    :placeholder="gettext('Последние ') + compiledCodeLength + gettext(' цифры звонка')"
                    :maxlength="compiledCodeLength"
                    :minlength="compiledCodeLength"
                    autocomplete="off"
                    autofocus=""
                    class="form-input_inner"
                    inputmode="numeric"
                    name="code"
                    ref="code"
                    type="text">
            </div>
        </div>
        <div class="fieldset-code_btn">
            <button
                class="antique-button antique-button__mobile-submit"
                type="submit"
                :data-at-role="qaDataAttributes.submit || 'submit'">
                <spinner :modifiers="['big-button']" v-if="processing"></spinner>
                {{ submitButtonText || gettext('Активировать') }}
            </button>
            <a
                :href="cancelOperationUrl"
                class="b-button-cancel b-button-cancel__block-mobile"
                data-at-role="cancel">
                {{ cancelButtonText || gettext('Отмена') }}
            </a>
        </div>

        <input-error
            v-if="errorType.code"
            :error-params="{ template: errorsTemplates.code }" />
        </fieldset>

    <sms-verification-resend-cellphone-recovery
        ref="resendCellphoneRecoveryComponent"
        @error="onResendCodeError"
        :operation="operation"
        sent-codes-prop-name="sentCodes">
        <slot name="resendCodeDescription"></slot>
    </sms-verification-resend-cellphone-recovery>
</form>
